import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import CreateRakeMovementForm from './CreateRakeMovementForm';

const CreateRakeMovementDialog = ({ open, onOpenChange, onCreateRakeMovement }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (rakeData) => {
    setIsSubmitting(true);
    try {
      const result = await onCreateRakeMovement(rakeData);
      return result;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto p-6">
        <DialogHeader className="mb-4">
          <DialogTitle className="text-lg font-semibold text-foreground">
            Create Rake Movement
          </DialogTitle>
        </DialogHeader>

        <CreateRakeMovementForm
          onCreateRakeMovement={handleSubmit}
          onCancel={() => onOpenChange(false)}
          isSubmitting={isSubmitting}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreateRakeMovementDialog;
